import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import SEOSchema from '@/components/feature/SEOSchema';
import HeroSection from './components/HeroSection';
import ServicesSection from './components/ServicesSection';
import CoursesSection from './components/CoursesSection';
import EventsSection from './components/EventsSection';
import VenuesSection from './components/VenuesSection';
import MembershipSection from './components/MembershipSection';
import YouthTrainingSection from './components/YouthTrainingSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <SEOSchema type="Organization" />
      <SEOSchema type="WebSite" />
      <SEOSchema
        type="WebPage"
        data={{
          name: '云开体育 - 专业体育服务平台',
          description: '云开体育提供体育培训、赛事组织、运动健身、体育场馆预约等一站式服务，致力于让更多人享受运动乐趣，助力全民健身事业蓬勃发展。',
        }}
      />

      <Navbar />

      <main>
        <article>
          <HeroSection />
          <ServicesSection />
          <CoursesSection />
          <EventsSection />
          <VenuesSection />
          <MembershipSection />
          <YouthTrainingSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>

      <Footer />
    </>
  );
}